import type { FieldError } from 'react-hook-form'
import type { IntlShape } from 'react-intl'

/**
 * Resolve a react-hook-form field error to display text. A message is either a
 * client-side zod i18n key (always prefixed, e.g. `payout.` / `coupon.`) or a
 * raw backend string mapped in via `setError`. Only the former is run through
 * the ICU formatter — so an untrusted server string is rendered verbatim, never
 * parsed as a template. `prefix` selects which keys are trusted for formatting.
 */
export const fieldErrorText = (
  formatMessage: IntlShape['formatMessage'],
  error: FieldError | undefined,
  prefix: string,
): string | undefined => {
  const message = error?.message
  if (message === undefined) {
    return undefined
  }

  return message.startsWith(prefix) ? formatMessage({ id: message }) : message
}
